var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"excel-button d-flex align-items-center justify-content-center",class:{'w-100': !!_vm.block}},'div',_vm.$attrs,false),_vm.$listeners),[_vm._m(0),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mr-2"},[_c('img',{staticStyle:{"max-height":"16px"},attrs:{"src":"/img/excel.png","alt":""}})])
}]

export { render, staticRenderFns }